<template>
  <div>
    <div :class="{ hidden: overLimit }">
      <el-upload
        v-if="!disabled"
        ref="upload"
        :action="action"
        :multiple="multiple"
        :show-file-list="false"
        :auto-upload="autoUpload"
        :accept="accept"
        :before-upload="beforeUpload"
        :drag="drag"
        :on-change="handleFileChange"
        :on-success="handleUpoladSuccess"
        :on-remove="handleFileRemove"
        :list-type="listType"
        :disabled="disabled"
        :data="data"
        :name="name"
        :limit="limit"
      >
        <slot>
          <i v-if="!drag" class="el-icon-plus" />
          <div v-if="drag" class="dragIcon">
            <i v-if="drag" class="el-icon-upload"></i>
            <span>点击或者拖拽文件上传</span>
          </div>
        </slot>
        <template #tip>
          <slot name="tip" />
        </template>
      </el-upload>
    </div>
    <div v-if="showFileList">
      <fileView
        v-for="file in fileList"
        :disabled="disabled"
        :key="file.url"
        :file="file"
        @deleteFile="removeFiles(file)"
      />
    </div>
  </div>
</template>
<script>
// import { Logout } from "../../../api/system/header";
import fileView from "../../common/fileView.vue";
export default {
  name: "AppUpload",
  components: { fileView },
  model: {
    prop: "url",
    event: "change",
  },
  props: {
    showFileList: {
      type: Boolean,
      default: true,
    },
    action: {
      type: String,
      default: process.env.BASE_API + "/oss/upload",
    },
    accept: {
      type: String,
      default: ".xlsx, .xls, .doc, .docx, .jpg, .png, .rar, .zip, .pdf,.html",
    },
    multiple: {
      type: Boolean,
      default: true,
    },
    drag: {
      type: Boolean,
      default: false,
    },
    limit: {
      type: Number,
      default: 1,
    },
    listType: {
      type: String,
      default: "picture-card",
    },
    autoUpload: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    url: {
      type: String,
    },
    data: {
      type: Object,
      default: () => ({}),
    },
    name: {
      type: String,
      default: "file",
    },
    list: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      fileList: [],
      overLimit: false,
    };
  },
  watch: {
    list: {
      immediate: true,
      handler(newVal) {
        this.fileList = newVal;
        this.overLimit = this.list.length >= this.limit;
      },
    },
  },
  mounted() {},
  computed: {
    token() {
      return localStorage.getItem("cbcloud-ssotoken");
    },
  },
  methods: {
    handleFileChange(file, fileList) {
      console.log(file, "file");
      // 如果单选，永远只有一个
      if (!this.multiple) {
        this.fileList = [];
      }
      if (this.fileList.length >= this.limit) {
        this.$message({
          message: "超出最大限制数量",
          type: "warning",
        });
        return;
      }
      if (file.response) {
        // 只管进，出由delete控制
        const newFile = {
          name: file.name,
          size: file.size,
          url: file.response.data.url,
        };
        this.fileList = [...this.fileList, newFile];
        this.$emit("handleFileList", this.fileList);
      }
    },
    removeFiles(file) {
      this.fileList = this.fileList.filter((f) => f != file);
      this.$emit("handleFileList", this.fileList);
    },
    beforeUpload(file) {
      const types = ["image/jpeg", "image/gif", "image/bmp", "image/png"];
      const isImage = types.includes(file.type);
      const isLtSize = file.size / 1024 / 1024;
      if (isImage && isLtSize > 5) {
        this.$message.warning("上传图片大小不能超过 5MB!");
        return false;
      }
      if (file.size > 1024 * 1024 * 300) {
        this.$message.warning("文件大小不能够超过 300MB!");
        return false;
      }
      return true;
    },
    handleUpoladSuccess(res) {
      if (res.code === "000000") {
        this.$message({ message: res.msg, type: "success" });
        this.$emit("success");
      } else {
        this.$message({ message: res.msg, type: "error" });
      }
      this.$refs.upload.clearFiles();
    },
    handleFileRemove() {
      this.fileUrl = "";
      this.$emit("change", this.fileUrl);
    },
  },
};
</script>
<style scoped lang="less">
/deep/ .el-upload-dragger {
  height: 140px;
}
.dragIcon {
  display: flex;
  flex-flow: column;
  color: #ccc;
}
.hidden {
  width: 0;
  overflow: hidden;
  height: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/childcomponents/AppUpload/index.vue